// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"effb3cda","595":"5e0226f2"}[chunkId] + ".chunk.js";
};